export interface CommunityDiscussionToolResult {
  id?: string | number;
  title?: string;
  snippet?: string | null;
  voteScore?: number;
  commentCount?: number;
  createdAt?: string;
  postSlug?: string;
  communityName?: string;
  communitySlug?: string;
  url?: string;
  isMember?: boolean;
  thumbnailUrl?: string | null;
}

export interface ParsedCommunityDiscussionToolOutput {
  results: CommunityDiscussionToolResult[];
  hasResults: boolean;
  message?: string;
}

export function parseCommunityDiscussionToolOutput(output: unknown): ParsedCommunityDiscussionToolOutput {
  if (!output || typeof output !== 'object') {
    return { results: [], hasResults: false };
  }

  const record = output as Record<string, unknown>;
  const results = Array.isArray(record.results) ? (record.results as CommunityDiscussionToolResult[]) : [];

  return {
    results,
    hasResults: results.length > 0,
    message: typeof record.message === 'string' ? record.message : undefined,
  };
}
